import ConversationsServerActionCreators from '../actions/ConversationsServerActionCreators';
import MessagesServerActionCreators from '../actions/MessagesServerActionCreators';
import MembersServerActionCreators from '../actions/MembersServerActionCreators';
import ConversationActionCreators from '../actions/ConversationActionCreators';

module.exports = {

  initConversations(conversations, unread_conversations) {
    ConversationsServerActionCreators.receiveConversations(conversations, unread_conversations);
  },

  initMessages(messages, openConversation, id) {
    MessagesServerActionCreators.receiveMessages(messages, openConversation, id);
  },

  initMembers(members, character_limit, limited_messages, over_conversation_limit, submit_on_enter, has_paid) {
    MembersServerActionCreators.receiveMembers(members, character_limit, limited_messages, over_conversation_limit, submit_on_enter, has_paid);
  },

};
